const general_tests_es = require('./general_tests.json')
export default general_tests_es